export default "__VITE_ASSET__kR_lE3Kz__"